import { Box, Button, Typography, useTheme } from "@mui/material";
import { useAuthStore } from "../../../../store/auth.store";
import { ReactComponent as HomeIcon } from "../assets/homeCurrentColor.svg";
import { useMetersStore } from "../../../../store/meters.store";

export function LicAccount() {
    const { accounts, setActiveAccount, setIsLoading } = useAuthStore();
    const { getMeters, getReadings } = useMetersStore();
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}
        >
            {accounts?.map((n) => {
                const fullAddress = [
                    n.address.region,
                    n.address.city,
                    n.address.street,
                    n.address.plot ? `уч. ${n.address.plot}` : n.address.building,
                    n.address.apartment,
                ]
                    .filter(Boolean) // убираем undefined, null и пустые строки
                    .join(", ");
                return (
                    <Box
                        sx={{
                            display: "flex",
                            padding: "20px",
                            borderRadius: "4px",
                            border: "1px solid #c5c5c5",
                            maxWidth: "502px",
                            gap: "16px",
                        }}
                        key={n.id}
                    >
                        <HomeIcon color="#c5c5c5" />
                        <Box>
                            <Typography>{fullAddress}</Typography>
                            <Typography variant="body2" color="#777">
                                Лицевой счёт: {n.external_id}
                            </Typography>
                            <Button
                                variant="text"
                                onClick={async () => {
                                    try {
                                        setIsLoading(true);
                                        await setActiveAccount(n.id);
                                        await getMeters();
                                        await getReadings();
                                    } catch (error) {
                                    } finally {
                                        setIsLoading(false);
                                    }
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color={theme.palette.primary.main}
                                >
                                    Посмотреть
                                </Typography>
                            </Button>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}
